import parseTextFromJson from "./parseOldArticle";

export function calculateChunksCount(chunksLength, maxInlineAds = 4) {
    if (chunksLength < 1) {
        return {adfoxNum: 0, paragraphNum: 0};
    }
    const minStep = 2;
    const inlineAds = Math.min(maxInlineAds, Math.floor(chunksLength / minStep));
    const step = inlineAds > 0 ? Math.max(minStep, Math.floor(chunksLength / (inlineAds + 1))) : 0;
    // +1 за блок перед текстом
    return {adfoxNum: inlineAds + 1, paragraphNum: step};
}

export function splitNewsContent(news, maxInlineAds = 4) {
    let el = document.createElement("div");
    if (news.content[0] === '{') {
        el.innerHTML = parseTextFromJson(news.content);
    } else {
        el.innerHTML = news.content;
    }
    const chunks = Array.from(el.children).map(el => el.innerHTML);
    const config = calculateChunksCount(chunks.length, maxInlineAds);
    if (config.adfoxNum > 0) {
        // первый блок — перед текстом
        chunks.splice(0, 0, "ADFOX");
        // остальные блоки — через каждые step абзацев
        const inlineAds = config.adfoxNum - 1;
        for (let i = 0; i < inlineAds; i++) {
            const insertPosition = 1 + config.paragraphNum * (i + 1) + i;
            if (insertPosition < chunks.length) {
                chunks.splice(insertPosition, 0, "ADFOX");
            }
        }
    }
    return chunks;
}
